import * as React from 'react';



import MobileResponsive from './mobile';
import DesktopResponsive from './desktop';
import { connect } from 'react-redux';
import { IAddressAppState } from '../../../address/redux-state';
import { ICalendarAppState } from '../../redux-state';
import { CalendarDeviceMode, CalendarViewMode } from '../../redux-state/interfaces/calendar-settings';
import { setToDesktop, setToMobile } from '../../redux-state/actions/calendar-settings.actions';

interface StateToProps {
    mediaWidth: number;
    currentDeviceMode: CalendarDeviceMode;

}

interface DispatchToProps {
    setToDesktop: () => void;
    setToMobile: () => void;
}

interface ResponsiveBaseState {
    WindowSize: number;
}

type ResponsiveProps = StateToProps & DispatchToProps;

export class ResponsiveBase extends React.Component<ResponsiveProps, any> {

    constructor(props: ResponsiveProps) {
        super(props);
        this.state = {
            WindowSize: window.innerWidth
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize.bind(this));
    }
    componentWillUnmount() {
        window.addEventListener("resize", null);
    }

    handleResize(WindowSize, event) : void {
        this.setState({ WindowSize: window.innerWidth })
        if (this.state.WindowSize > this.props.mediaWidth && this.props.currentDeviceMode != CalendarDeviceMode.DESKTOP) {
            this.props.setToDesktop();
        }
        else if (this.state.WindowSize < this.props.mediaWidth && this.props.currentDeviceMode != CalendarDeviceMode.MOBILE) {
            this.props.setToMobile();
        }
    }

    render() {
        return (
            <>
                
            </>
        )
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        mediaWidth: Number(state.calendarSettings.desktopToMobileTransitionWidth),
        currentDeviceMode: state.calendarSettings.calendarDeviceMode
    }
}
function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToDesktop: () => dispatch(setToDesktop()),
        setToMobile: () => dispatch(setToMobile())
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ResponsiveBase);